import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
const StyledNavLink = styled(NavLink) `
  color: ${p => p.theme.linkColor};
  text-decoration: none;

  &:hover {
    text-decoration: underline solid;
    color: ${p => p.theme.fontColor};
  }
`;
export default function StyledLink(props) {
    return React.createElement(StyledNavLink, Object.assign({}, props), props.children);
}
